/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown> }} Agenda_Journey_Suggestion_PillInputs */



/**
* | output |
* | --- |
* | "{name} · step {position}?" |
*
* @param {Agenda_Journey_Suggestion_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_journey_suggestion_pill = /** @type {((inputs: Agenda_Journey_Suggestion_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Journey_Suggestion_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} · stap ${i?.position}?`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} · étape ${i?.position} ?`)
	return /** @type {LocalizedString} */ (`${i?.name} · step ${i?.position}?`)
});